import CliError from './CliError';

const INVALID_BUILD_ID_SEGMENTS = new Set(['.', '..']);
const INVALID_BUILD_ID_PATH_SEPARATOR = /[\\/]/;

export default function validateBuildIdArg({
  buildId,
  commandUsed,
}: {
  buildId?: string;
  commandUsed: string;
}): void {
  const baseCommand = normalizeCommandUsed(commandUsed);

  if (!buildId || buildId === 'latest') {
    return;
  }

  if (INVALID_BUILD_ID_SEGMENTS.has(buildId)) {
    throw new CliError(
      `Invalid build ID "${buildId}". ${baseCommand} does not accept a project path. ` +
        `Use \`${baseCommand}\`, \`${baseCommand} --latest\`, or \`${baseCommand} <build-id>\`.`,
      { type: 'build-error' },
    );
  }

  if (INVALID_BUILD_ID_PATH_SEPARATOR.test(buildId)) {
    throw new CliError(
      `Invalid build ID "${buildId}". Build IDs cannot contain path separators. ` +
        `Use \`${baseCommand} --latest\` or \`${baseCommand} <build-id>\`.`,
      { type: 'build-error' },
    );
  }
}

function normalizeCommandUsed(commandUsed: string): string {
  return commandUsed.replace(/ (?:<id>|--latest)$/, '');
}
